import React from 'react';
import { Tabs } from 'antd';
import BQRoutineManagement from './BQRoutineManagement';
import CampaignGeneration from './CampaignGeneration';
import EmailExclusion from './EmailExclusion';
const { TabPane } = Tabs;

export default function Phase1() {
  return (
    <Tabs defaultActiveKey="3">
      <TabPane key="1" tab="BigQuery Routines Default Value Management">
        <BQRoutineManagement />
      </TabPane>
      <TabPane key="2" tab="Campaign Generation">
        <CampaignGeneration />
      </TabPane>
      <TabPane key="3" tab="Email Exclusions">
        <EmailExclusion />
      </TabPane>
    </Tabs>
  );
}
